import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { merge } from "lodash";

const fetchLocalResources = async () => {
  try {
    const localRequest = await fetch("/da.json");
    if (!localRequest.ok) {
      throw new Error(`Failed to fetch local translations: ${localRequest.status}`);
    }

    return await localRequest.json();
  } catch {
    console.error("Failed to load local translation resources");
    return {};
  }
};

const fetchResources = async () => {
  try {
    const globalLoadPath =
      "https://api.i18nexus.com/project_resources/translations/da/default.json?api_key=Y1rOfKm7xtIxVYtoNc91Lg";
    const globalRequest = await fetch(globalLoadPath);
    const globalResources = globalRequest.json();

    const loadPath =
      "https://api.i18nexus.com/project_resources/translations/da/default.json?api_key=yN_0dQPzPibsDUGMc30d7g";
    const spaRequest = await fetch(loadPath);
    const spaResources = spaRequest.json();

    const response = await Promise.all([globalResources, spaResources]);
    return merge({}, ...response);
  } catch {
    console.error("Failed to load i18nexus resources, falling back to local translations");
    return fetchLocalResources();
  }
};

const backendOptions = {
  request: (
    _options: unknown,
    _url: unknown,
    _payload: unknown,
    callback: (error: unknown, response: { data?: unknown; status: number }) => void,
  ) => {
    try {
      fetchResources().then((response) => {
        callback(null, {
          data: response,
          status: 200,
        });
      });
    } catch {
      callback(null, { status: 500 });
    }
  },
};

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    interpolation: { escapeValue: false },
    // somehow fetching resources from i18nexus is not working in Cypress, so we disable the backend in that case
    backend: import.meta.env.VITE_MODE === "cypress" ? false : backendOptions,
  });

export { default } from "i18next";
